import {ISpecialWallet} from '../../types/models/SpecialWallet';

export const FETCH_SPECIAL_WALLETS = 'FETCH_SPECIAL_WALLETS';
export const FETCH_SPECIAL_WALLETS_SUCCESS = 'FETCH_SPECIAL_WALLETS_SUCCESS';
export const FETCH_SPECIAL_WALLETS_ERROR = 'FETCH_SPECIAL_WALLETS_ERROR';
export const EXECUTE_SPECIAL_WALLET_TRANSACTION =
  'EXECUTE_SPECIAL_WALLET_TRANSACTION';
export const EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS =
  'EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS';
export const EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR =
  'EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR';

export const EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS_REDIRECTING =
  'EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS_REDIRECTING';

export interface FetchSpecialWallets {
  type: typeof FETCH_SPECIAL_WALLETS;
}

export interface FetchSpecialWalletsSuccess {
  type: typeof FETCH_SPECIAL_WALLETS_SUCCESS;
  payload: ISpecialWallet[];
}

export interface FetchSpecialWalletsError {
  type: typeof FETCH_SPECIAL_WALLETS_ERROR;
}

export interface ExecuteSpecialWalletTransaction {
  type: typeof EXECUTE_SPECIAL_WALLET_TRANSACTION;
}

export interface ExecuteSpecialWalletTransactionSuccess {
  type: typeof EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS;
  payload: boolean;
}

export interface ExecuteSpecialWalletTransactionError {
  type: typeof EXECUTE_SPECIAL_WALLET_TRANSACTION_ERROR;
}

export interface ExecuteSWTRedirecting {
  type: typeof EXECUTE_SPECIAL_WALLET_TRANSACTION_SUCCESS_REDIRECTING;
  payload: boolean;
}

export type SpecialWalletsActions =
  | FetchSpecialWallets
  | FetchSpecialWalletsSuccess
  | FetchSpecialWalletsError
  | ExecuteSpecialWalletTransaction
  | ExecuteSpecialWalletTransactionSuccess
  | ExecuteSpecialWalletTransactionError
  | ExecuteSWTRedirecting;
